import checkmarkIcon from 'assets/icons/icon-checkmark-12.svg';
import { motion } from 'framer-motion';
import React from 'react';
import { Button } from 'shared/components';

interface Props {
  id: string;
  stepNumber: number;
  isLastStep?: boolean;
  title: string;
  summary?: string;
  isExpanded: boolean;
  isComplete: boolean;
  isLocked: boolean;
  onToggle: () => void;
  children: React.ReactNode;
}

export const ProposalAIGeneratorCollapsibleSection: React.FC<Props> = ({
  id,
  stepNumber,
  isLastStep,
  title,
  summary,
  isExpanded,
  isComplete,
  isLocked,
  onToggle,
  children,
}) => (
  <div className="proposal-ai-generator__step">
    <div className="proposal-ai-generator__step-rail">
      <div
        className={`proposal-ai-generator__step-badge ${
          isComplete ? 'done' : isLocked ? 'locked' : 'is-active'
        }`}
      >
        {isComplete ? (
          <img
            src={checkmarkIcon}
            className="btn__icon"
            alt=""
            aria-hidden="true"
          />
        ) : (
          stepNumber
        )}
      </div>
      {!isLastStep && <div className="proposal-ai-generator__step-line" />}
    </div>

    <div className="proposal-ai-generator__step-content">
      <Button
        type="button"
        onClick={onToggle}
        disabled={isLocked}
        className="f f--between-center proposal-ai-generator__collapsible-header"
        ariaLabel={title}
        ariaExpanded={isExpanded}
        ariaControls={id}
      >
        <span className="proposal-ai-generator__collapsible-heading">
          <span className="t-label t-text-3">{title}</span>
          {!isExpanded && summary && (
            <span className="t-text-2 proposal-ai-generator__collapsible-summary">
              {summary}
            </span>
          )}
        </span>

        {!isLocked && (
          <motion.svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            className="btn__icon f--shrink-zero"
            animate={{ rotate: isExpanded ? 0 : -180 }}
            transition={{ duration: 0.2, ease: 'easeOut' }}
            fill="none"
          >
            <path
              d="M11 9.17188L8.17157 6.34345L5.34314 9.17188"
              stroke="#706F6F"
              strokeWidth="0.75"
            />
          </motion.svg>
        )}
      </Button>

      <div
        id={id}
        className={`proposal-ai-generator__collapsible-body ${
          isExpanded ? 'proposal-ai-generator__collapsible-body--expanded' : ''
        }`}
      >
        <div className="proposal-ai-generator__collapsible-content">
          {children}
        </div>
      </div>
    </div>
  </div>
);
